import {Component, EventEmitter, Input, Output} from '@angular/core';
import {SatPopover} from '@ncstate/sat-popover';

@Component({
  selector: 'app-drag-popover',
  templateUrl: './drag-popover.component.html',
})
export class DragPopoverComponent {
  @Input() index: number;
  @Output() dragEvent: EventEmitter<{ previousIndex: number, currentIndex: number, }> = new EventEmitter();
  popupIsOpen = false;
  popupItems = [
    {
      iconName: 'ic-pagination_up',
      title: 'Move up',
      direction: 'next',
    },
    {
      iconName: 'ic-pagination_down',
      title: 'Move down',
      direction: 'prev',
    }
  ];

  constructor() {
  }

  clickPopupItem(popover: SatPopover, direction: 'next' | 'prev') {
    this.dragEvent.emit({
      previousIndex: this.index,
      currentIndex: direction === 'next' ? this.index - 1 : this.index + 1,
    });
    if (popover) {
      popover.close();
    }
  }
}
